import React from 'react';
import styled from 'styled-components';

const LandingSectionHeader = (props) => {
  const {title, subtitle, color = '#fff'} = props;
  return (
    <Wrapper color={color}>
      <div className="header-line" />
      <div className="title">{title}</div>
      <div className="subtitle">{subtitle}</div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-bottom: 50px;
  & > .header-line {
    margin-bottom: 15px;
    height: 9px;
    width: 210px;
    background-color: ${({color}) => `${color}`};
  }

  & > .title,
  .subtitle {
    font-family: MavenPro, sans-serif;
    font-size: 26px;
    font-weight: 500;
    line-height: 1.57;
    text-align: left;
    color: ${({color}) => `${color}`};
    white-space: nowrap;
  }
`;

export default LandingSectionHeader;
